import { LookIdEnum } from "../../handlers/types";

export const LOOKS_SPRITES: Record<string, string> = {
  [LookIdEnum.BASIC]: "char1",
  [LookIdEnum.BLUE_GIRL]: "char2",
  [LookIdEnum.PHANTOM]: "char3",
  [LookIdEnum.MAN_IN_MASK]: "char4",
  [LookIdEnum.GREEN_GIRL]: "char5",
  [LookIdEnum.WISE_MAGE]: "char6",
  [LookIdEnum.PUNK]: "char7",
  [LookIdEnum.MAN_IN_BLUE]: "char8",
  [LookIdEnum.EVIL_ORC]: "char9",
  [LookIdEnum.BONE_MASK]: "char10",

  //2nd wave of skins
  [LookIdEnum.BAT]: LookIdEnum.BAT.toLocaleLowerCase(),
  [LookIdEnum.DEMON_PRINCESS]: LookIdEnum.DEMON_PRINCESS.toLocaleLowerCase(),
  [LookIdEnum.DETECTIVE]: LookIdEnum.DETECTIVE.toLocaleLowerCase(),
  [LookIdEnum.DWARF_PRINCESS]: LookIdEnum.DWARF_PRINCESS.toLocaleLowerCase(),
  [LookIdEnum.FURRY]: LookIdEnum.FURRY.toLocaleLowerCase(),
  [LookIdEnum.GOBLIN]: LookIdEnum.GOBLIN.toLocaleLowerCase(),
  [LookIdEnum.KEK]: LookIdEnum.KEK.toLocaleLowerCase(),
  [LookIdEnum.JUSTICE]: LookIdEnum.JUSTICE.toLocaleLowerCase(),
  [LookIdEnum.LEPRIKON]: LookIdEnum.LEPRIKON.toLocaleLowerCase(),
  [LookIdEnum.NERD_GIRL]: LookIdEnum.NERD_GIRL.toLocaleLowerCase(),
  [LookIdEnum.NOMAD]: LookIdEnum.NOMAD.toLocaleLowerCase(),
  [LookIdEnum.VALKYRIE]: LookIdEnum.VALKYRIE.toLocaleLowerCase(),
  [LookIdEnum.ROBO_POLICE]: LookIdEnum.ROBO_POLICE.toLocaleLowerCase(),
  [LookIdEnum.SKELETON_PRIEST]: LookIdEnum.SKELETON_PRIEST.toLocaleLowerCase(),
  [LookIdEnum.VIKING]: LookIdEnum.VIKING.toLocaleLowerCase(),
};
